var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaVideoLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997",
    transform: "translate(-713 -1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 40,
    height: 40,
    transform: "translate(713 1280)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "film",
    transform: "translate(719 1287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 22,
    height: 22,
    rx: 2.18,
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y2: 22,
    transform: "translate(8 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    y2: 22,
    transform: "translate(18 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 22,
    transform: "translate(2 12)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 4.806,
    transform: "translate(2 7.407)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 4.806,
    transform: "translate(2 18.221)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x2: 4.806,
    transform: "translate(18.822 18.221)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 4.806,
    transform: "translate(18.822 7.407)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaVideoLargeIcon);
export default __webpack_public_path__ + "static/media/media-video-large-icon.badda1e51449288ddbfa14288f19dfa0.svg";
export { ForwardRef as ReactComponent };